The input parameter for the `createApplicationQuestionnaire` mutation.

This must not exceed 56 KiB in length.
